module.exports = __webpack_public_path__ + "img/bg-order-two.eebfd51d.png";